import '@fontsource/barlow-condensed/500.css';
import '@fontsource/barlow-condensed/600.css';
import '@fontsource/barlow-condensed/700.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './styles/tokens.css';
import './styles/components.css';
import './styles/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { startAutosave } from './state/persist';

startAutosave();

// Optional, cookieless analytics (Umami). Only loaded when both variables are set at build time.
const umamiSrc = import.meta.env.VITE_UMAMI_SRC as string | undefined;
const umamiId = import.meta.env.VITE_UMAMI_WEBSITE_ID as string | undefined;
if (umamiSrc && umamiId) {
  const s = document.createElement('script');
  s.defer = true;
  s.src = umamiSrc;
  s.dataset.websiteId = umamiId;
  document.head.appendChild(s);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
